import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQPage = () => {
  // Sample FAQ data
  const faqs = [
    {
      question: "What types of wedding photography services do you offer?",
      answer:
        "We offer a wide range of services including pre-wedding shoots, full-day wedding coverage, destination weddings, and custom packages tailored to your needs.",
    },
    {
      question: "How far in advance should we book your services?",
      answer:
        "We recommend booking at least 6-12 months in advance to ensure availability, especially during peak wedding seasons.",
    },
    {
      question: "Do you travel for destination weddings?",
      answer:
        "Yes, we love capturing destination weddings! Travel and accommodation fees may apply, depending on the location.",
    },
    {
      question: "How many photos will we receive?",
      answer:
        "The number of photos depends on the package you choose, but typically, we deliver 400-800 high-resolution edited images for a full-day wedding.",
    },
    {
      question: "Do you provide edited images?",
      answer:
        "Yes, all images are professionally edited to ensure the highest quality and consistency.",
    },
    {
      question: "What is your cancellation policy?",
      answer:
        "Cancellations made 30 days prior to the wedding date will receive a partial refund, depending on the agreement. For details, please check your contract or contact us.",
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      {/* Page Header */}
      <Typography
        variant="h4"
        align="center"
        sx={{ fontWeight: 'bold', mb: 4, textTransform: 'uppercase' }}
      >
        Frequently Asked Questions
      </Typography>

      {/* FAQ Section */}
      <Box>
        {faqs.map((faq, index) => (
          <Accordion key={index} sx={{ mb: 2 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`faq-content-${index}`}
              id={`faq-header-${index}`}
            >
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1">{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Container>
  );
};

export default FAQPage;
